<ng-container [ngSwitch]="variant">
    <ng-container *ngSwitchCase="'stroked'">
        <div class="flex flex-row split-button">
            <ng-container *ngIf="disabled === true">
                <v2-button-wrapper
                    [variant]="variant"
                    [color]="color"
                    [text]="'dropdown'"
                    [size]="size"
                    [disabled]="disabled"
                    class="first-button"
                ></v2-button-wrapper>
                <v2-button-wrapper
                    [icon]="'angle-down'"
                    [size]="size"
                    [variant]="variant"
                    [color]="color"
                    [disabled]="disabled"
                    class="second-button v2-menu-trigger"
                >
                </v2-button-wrapper>
            </ng-container>

            <ng-container *ngIf="disabled === false">
                <v2-button-wrapper
                    [variant]="variant"
                    [color]="color"
                    [text]="'dropdown'"
                    [size]="size"
                    [disabled]="disabled"
                    (click)="clicked.emit()"
                    class="first-button"
                ></v2-button-wrapper>
                <v2-button-wrapper
                    [icon]="'angle-down'"
                    [size]="size"
                    [variant]="variant"
                    [color]="color"
                    [disabled]="disabled"
                    [matMenuTriggerFor]="menu"
                    class="second-button v2-menu-trigger"
                >
                </v2-button-wrapper>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'raised'">
        <div class="flex flex-row split-button border-button">
            <ng-container *ngIf="disabled === true">
                <v2-button-wrapper
                    [variant]="variant"
                    [color]="color"
                    [text]="'dropdown'"
                    [size]="size"
                    [disabled]="disabled"
                    class="first-button"
                ></v2-button-wrapper>
                <v2-button-wrapper
                    [icon]="'angle-down'"
                    [size]="size"
                    [variant]="variant"
                    [color]="color"
                    [disabled]="disabled"
                    class="second-button v2-menu-trigger"
                >
                </v2-button-wrapper>
            </ng-container>

            <ng-container *ngIf="disabled === false">
                <v2-button-wrapper
                    [variant]="variant"
                    [color]="color"
                    [text]="'dropdown'"
                    [size]="size"
                    [disabled]="disabled"
                    (click)="clicked.emit()"
                    class="first-button"
                ></v2-button-wrapper>
                <v2-button-wrapper
                    [icon]="'angle-down'"
                    [size]="size"
                    [variant]="variant"
                    [color]="color"
                    [disabled]="disabled"
                    [matMenuTriggerFor]="menu"
                    class="second-button v2-menu-trigger"
                >
                </v2-button-wrapper>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'flat'">
        <div class="flex flex-row split-button">
            <ng-container *ngIf="disabled === true">
                <v2-button-wrapper
                    class="btn-{{ color }}"
                    [variant]="variant"
                    [color]="color"
                    [text]="'dropdown'"
                    [disabled]="disabled"
                    [size]="size"
                    class="first-button"
                >
                </v2-button-wrapper>
                <v2-button-wrapper
                    [icon]="'angle-down'"
                    [size]="size"
                    [variant]="variant"
                    [color]="color"
                    [disabled]="disabled"
                    class="second-button v2-menu-trigger"
                >
                </v2-button-wrapper>
            </ng-container>

            <ng-container *ngIf="disabled === false">
                <v2-button-wrapper
                    class="btn-{{ color }}"
                    [variant]="variant"
                    [color]="color"
                    [text]="'dropdown'"
                    [disabled]="disabled"
                    [size]="size"
                    (click)="clicked.emit()"
                    class="first-button"
                >
                </v2-button-wrapper>
                <v2-button-wrapper
                    [icon]="'angle-down'"
                    [size]="size"
                    [variant]="variant"
                    [color]="color"
                    [disabled]="disabled"
                    [matMenuTriggerFor]="menu"
                    matMenu
                    class="second-button v2-menu-trigger"
                >
                </v2-button-wrapper>
            </ng-container>
        </div>
    </ng-container>
</ng-container>

<mat-menu #menu="matMenu" [backdropClass]="size" class="v2-menu">
    <button mat-menu-item *ngFor="let item of items" (click)="selectItem(item)">
        {{ item.title }}
    </button>
</mat-menu>
